const nameApplications = {
  gitlab: "Gitlab",
  openvpn: "VPN",
  airbyte: "Airbyte",
  opensearch: "OpenSearch",
  alb: "Aplicaciones AWS",
};

export default nameApplications;
